import { FC } from 'react'

const CommentMentorPostIcon: FC = () => {
  return (
    <svg
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <desc>댓글 아이콘</desc>
      <g clipPath="url(#clip0_981_123)">
        <path
          d="M20.5 40.5C31.5457 40.5 40.5 31.5457 40.5 20.5C40.5 9.4543 31.5457 0.5 20.5 0.5C9.4543 0.5 0.5 9.4543 0.5 20.5C0.5 31.5457 9.4543 40.5 20.5 40.5Z"
          fill="white"
          stroke="#EEEEEE"
        />
        <path
          d="M24.592 28.25L25.968 26.706L26.402 26.591C27.1471 26.3918 27.8055 25.9522 28.2753 25.3405C28.745 24.7288 28.9998 23.9792 29 23.208V16C29 14.07 27.43 12.5 25.5 12.5H15.5C13.57 12.5 12 14.07 12 16V23.208C12 25.138 13.57 26.708 15.5 26.708H23.217L24.592 28.25ZM24.592 30C24.4509 30.0003 24.3114 29.9707 24.1827 29.9132C24.0539 29.8556 23.9388 29.7713 23.845 29.666L22.545 28.208H15.5C14.1739 28.208 12.9021 27.6812 11.9645 26.7435C11.0268 25.8059 10.5 24.5341 10.5 23.208V16C10.5 14.6739 11.0268 13.4021 11.9645 12.4645C12.9021 11.5268 14.1739 11 15.5 11H25.5C26.8261 11 28.0979 11.5268 29.0355 12.4645C29.9732 13.4021 30.5 14.6739 30.5 16V23.208C30.5 24.31 30.1362 25.3811 29.465 26.255C28.7937 27.129 27.8527 27.7568 26.788 28.041L25.338 29.666C25.2443 29.7712 25.1294 29.8554 25.0008 29.913C24.8722 29.9705 24.7329 30.0002 24.592 30Z"
          fill="#01A0FF"
        />
        <path
          d="M26.5 11.5H14.5C12.8431 11.5 11.5 12.8431 11.5 14.5V24.5C11.5 26.1569 12.8431 27.5 14.5 27.5H26.5C28.1569 27.5 29.5 26.1569 29.5 24.5V14.5C29.5 12.8431 28.1569 11.5 26.5 11.5Z"
          fill="#01A0FF"
        />
        <path
          d="M17.8718 23H16.7638L19.9684 14.2727H21.0593L24.2638 23H23.1559L20.5479 15.6534H20.4798L17.8718 23ZM18.2809 19.5909H22.7468V20.5284H18.2809V19.5909Z"
          fill="white"
        />
        <path
          d="M22.7749 26.6289L24.3749 28.9529L26.2349 26.6289H22.7749Z"
          fill="#01A0FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_981_123">
          <rect width="41" height="41" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default CommentMentorPostIcon
